import * as React from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from "primereact/button";
import AlertMessage from '../../common/components/alertMessage/alertMessage';
import { DisposalPlacesModel } from '../../models/disposalPlaces/disposalPlaces';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import * as HelperFunctions from '../../common/functions/helperFunctions';
import Language from '../../common/components/language/language';
import { Lang } from '../../common/enums';

interface IProps {
    saveClick: any,
    cancelClick: any,
    isVisible: boolean,
    currentDisposalPlace: DisposalPlacesModel
}

interface IState {
    disposalPlace: DisposalPlacesModel,
    validationMessage: string,
    diseaseValidationMessage: string,
    isVisibleDiseaseListDialog: boolean,
    timePeriodFrom: string,
    timePeriodTo: string,
    selectedLangId: number
}

class DisposalPlaceAddEditDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props);

        this.state = {
            disposalPlace: props.currentDisposalPlace,
            validationMessage: '',
            diseaseValidationMessage: '',
            isVisibleDiseaseListDialog: false,
            timePeriodFrom: '',
            timePeriodTo: '',
            selectedLangId: Lang.bg
        };
    }

    componentDidMount() {
        if (this.state.disposalPlace && this.state.disposalPlace.interval && this.state.disposalPlace.interval.trim() != '') {
            let timePeriods = this.splitPeriods(this.state.disposalPlace.interval);
            if (timePeriods.length > 0) {
                this.setState({ timePeriodFrom: timePeriods[0], timePeriodTo: timePeriods[1] });
            }
        }
    }

    splitPeriods(period: string) {
        period = period.trim();
        let splittedPeriods = period.split("-");
        splittedPeriods[0] = splittedPeriods[0].trim();
        splittedPeriods[1] = splittedPeriods[1].trim();
        return splittedPeriods;
    }

    handleChange = (key, value) => {
        const disposalPlace: DisposalPlacesModel = { ...this.state.disposalPlace };
        disposalPlace[key] = value;
        this.setState({ disposalPlace: { ...disposalPlace } });
    };

    handleIntervalChange = (key, value) => {
        if (key == 1) {
            this.setState({ timePeriodFrom: value });
        } else {
            this.setState({ timePeriodTo: value });
        }
    }

    isValidAddEditForm() {
        let message = '';
        const timeRegex = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/i;
        if (this.state.timePeriodFrom && this.state.timePeriodFrom.trim() != '' && !timeRegex.test(this.state.timePeriodFrom)) {
            message += "Period from not valid. <br />";
        }

        if (this.state.timePeriodTo && this.state.timePeriodFrom.trim() != '' && !timeRegex.test(this.state.timePeriodTo)) {
            message += "Period to not valid. <br />";
        }

        this.setState({
            validationMessage: message
        });

        return message == '';
    }

    handleSaveButton = (event) => {
        event.preventDefault();
        if (!this.isValidAddEditForm()) return;

        const disposalPlace = { ...this.state.disposalPlace };
        if (this.state.timePeriodFrom && this.state.timePeriodFrom.trim() != '' && this.state.timePeriodTo && this.state.timePeriodTo.trim() != '') {
            disposalPlace.interval = `${this.state.timePeriodFrom} - ${this.state.timePeriodTo}`;
        }
        else {
            disposalPlace.interval = undefined;
        }
        disposalPlace.date = HelperFunctions.fomatDateAsString(new Date(disposalPlace.date));
        this.props.saveClick(disposalPlace, true);
    }

    handleCancelButton = () => {
        this.props.cancelClick();
    }

    onLangChange = (lang) => {
        this.setState({ selectedLangId: lang });
    }

    getValueContent = (key) => {
        let content = this.state.disposalPlace.disposalPlacesContent.find(r => r.langId == this.state.selectedLangId)
        if (content && content[key]) {
            return content[key];
        }
        return '';
    }

    handleChangeContent = (key, value) => {
        const disposalPlace: DisposalPlacesModel = { ...this.state.disposalPlace };
        let content = disposalPlace.disposalPlacesContent.find(r => r.langId == this.state.selectedLangId);
        if (content) {
            content[key] = value;
        }
        this.setState({ disposalPlace: { ...disposalPlace } });
    };


    public render() {

        const { disposalPlace, selectedLangId } = this.state;
        const size: number = 10;

        let header = 'Disposal place ' +
            (disposalPlace.address ? ' -' : '') +
            (disposalPlace.address ? ' ' + disposalPlace.address : '');

        return (
            <>
                <Dialog header={header} responsive={true} width="80%"
                    modal={true}
                    visible={this.props.isVisible}
                    onHide={this.handleCancelButton}
                    footer={
                        <div>
                            <Button label="Save" icon="pi pi-save" onClick={(e) => this.handleSaveButton(e)} className="p-button-raised"
                                disabled={!disposalPlace.date || !disposalPlace.latitude || !disposalPlace.longtitude} />
                            <Button label="Cancel" icon="pi pi-times" onClick={this.handleCancelButton} className="p-button-secondary p-button-raised" />
                        </div>}
                >
                    <div style={{ minHeight: '550px', maxHeight: '650px' }}>
                        {this.state.validationMessage ? <AlertMessage type='danger'>{this.state.validationMessage}</AlertMessage> : null}
                        <div style={{ maxWidth: '70px' }}>
                            <Language selectedLang={selectedLangId} onLangChange={this.onLangChange}></Language>
                        </div>
                        <div className="p-grid p-fluid">
                            <div className="p-col-12 p-md-3">
                                <label>City:</label>
                                <InputText
                                    name="city"
                                    onChange={(e) => this.handleChangeContent('city', e.target['value'])}
                                    value={this.getValueContent('city')}
                                />
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label>Region:</label>
                                <InputText
                                    name="region"
                                    onChange={(e) => this.handleChangeContent('region', e.target['value'])}
                                    value={this.getValueContent('region')}
                                />
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label>Address:</label>
                                <InputText
                                    name="address"
                                    onChange={(e) => this.handleChangeContent('address', e.target['value'])}
                                    value={this.getValueContent('address')}
                                />
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label>Date:</label>
                                <Calendar
                                    dateFormat="dd.mm.yy г."
                                    showButtonBar={true}
                                    //showTime={true}
                                    // showSeconds={true}
                                    // hideOnDateTimeSelect={true}
                                    // disabled={true}
                                    monthNavigator={true}
                                    yearNavigator={true}
                                    yearRange="1950:2050"
                                    name="birthDate"
                                    showIcon={true}
                                    readOnlyInput={true}
                                    value={disposalPlace.date ? new Date(disposalPlace.date) : undefined}
                                    onChange={(e) => this.handleChange('date', e.value)}
                                />
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label>Latitude:</label>
                                <InputText
                                    keyfilter="num"
                                    name="latitude"
                                    onChange={(e) => this.handleChange('latitude', e.target['value'])}
                                    value={disposalPlace && disposalPlace.latitude ? disposalPlace.latitude : ""}
                                />
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label>Longtitude:</label>
                                <InputText
                                    keyfilter="num"
                                    name="longtitude"
                                    onChange={(e) => this.handleChange('longtitude', e.target['value'])}
                                    value={disposalPlace && disposalPlace.longtitude ? disposalPlace.longtitude : ""}
                                />
                            </div>
                            <div className="p-col-12 p-md-3">
                                <label>Interval:</label>
                                <div style={{ width: '100%' }}>
                                    <InputText
                                        maxLength={5}
                                        pattern="([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]"
                                        name="timeperiodFrom"
                                        style={{ width: 55 }}
                                        keyfilter={/[\d:\-\.]/}
                                        onChange={(e) => this.handleIntervalChange(1, e.target['value'])}
                                        value={this.state.timePeriodFrom}
                                        required
                                    />{' - '}
                                    <InputText
                                        pattern="([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]"
                                        maxLength={5}
                                        style={{ width: 55 }}
                                        name="timeperiodTo"
                                        keyfilter={/[\d:\-\.]/}
                                        onChange={(e) => this.handleIntervalChange(2, e.target['value'])}
                                        value={this.state.timePeriodTo}
                                        required
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="p-col-12 p-md-12">
                            <label>Description:</label>
                            <InputTextarea
                                name="description"
                                rows={4}
                                value={this.getValueContent('description')}
                                style={{ width: '100%' }}
                                onChange={(e) => this.handleChangeContent('description', e.target['value'])}
                            />
                        </div>
                    </div>
                </Dialog >
            </>
        )
    }
}

export default DisposalPlaceAddEditDialog;